var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99941 11.1941C11.4354 11.1941 12.5994 10.0301 12.5994 8.59414C12.5994 7.1582 11.4354 5.99414 9.99941 5.99414C8.56347 5.99414 7.39941 7.1582 7.39941 8.59414C7.39941 10.0301 8.56347 11.1941 9.99941 11.1941Z",
    stroke: "#00A4D4",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01675 7.0724C4.65842 -0.144269 15.3501 -0.135935 16.9834 7.08073C17.9417 11.3141 15.3084 14.8974 13.0001 17.1141C11.3251 18.7307 8.67508 18.7307 6.99175 17.1141C4.69175 14.8974 2.05842 11.3057 3.01675 7.0724Z",
    stroke: "#00A4D4",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLocation);
export default __webpack_public_path__ + "static/media/blue-location.ed336c3443b3082f84bdf2bb3284d317.svg";
export { ForwardRef as ReactComponent };